export interface InvoiceItem {
  value: number; 
}

export class Invoice {
  invoiceItem: InvoiceItem[];

  constructor(data: any = {}) {
    this.invoiceItem = data.invoiceItem || [];
  }
}